// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

export enum SimulationRunState {
  PENDING = 0,
  STARTING = 1,
  RUNNING = 2,
  STOPPING = 3,
  STOPPED = 4,
  FAILED = 5,
}
